import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

/* Material API and Design in general*/
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatStepperModule } from '@angular/material/stepper';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSliderModule } from '@angular/material/slider';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/* Firebase services */
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';

/* Services */
import { HelpersService } from 'src/app/services/helpers.service';
import { AuthService } from './services/auth.service';

/* Components */
import { AppComponent } from './app.component';
import { LoginComponent } from './components/shared/login/login.component';
import { ResultadoComponent } from './components/resultado/resultado.component';
import { DetalhesComponent } from './components/detalhes/detalhes.component';
import { LoadingSpinnerComponent } from './components/shared/loading-spinner/loading-spinner.component';
import { AvaliadorComponent } from './components/avaliador/avaliador.component';

import { CriarQuestaoComponent } from './components/mentoria/criar-questao/criar-questao.component';
import { QuestaoComponent } from './components/mentoria/questao/questao.component';
import { RespostaComponent } from './components/mentoria/resposta/resposta.component';

import { EquipeslistComponent } from './components/participante/equipeslist/equipeslist.component';
import { ResumoEquipeComponent } from './components/participante/resumo-equipe/resumo-equipe.component';
import { EscolhaDesafioComponent } from './components/participante/escolha-desafio/escolha-desafio.component';
import { EntregaslistComponent } from './components/participante/entregaslist/entregaslist.component';
import { MenuComponent } from './components/shared/menu/menu.component';
import { MudarPerfilComponent } from './components/shared/mudar-perfil/mudar-perfil.component';
import { ServiceWorkerModule } from '@angular/service-worker';

/* Modulos adicionais */
import { HttpClientModule} from '@angular/common/http';

// Angular text editor https://www.npmjs.com/package/@kolkov/angular-editor
import { AngularEditorModule } from '@kolkov/angular-editor';

@NgModule({
  declarations: [
    AppComponent,
    QuestaoComponent,
    LoadingSpinnerComponent,
    RespostaComponent,
    LoginComponent,
    CriarQuestaoComponent,
    AvaliadorComponent,
    ResultadoComponent,
    DetalhesComponent,
    EquipeslistComponent,
    ResumoEquipeComponent,
    EscolhaDesafioComponent,
    EntregaslistComponent,
    MenuComponent,
    MudarPerfilComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    AngularFireAuthModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    MatTabsModule,
    MatMenuModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatStepperModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatSelectModule,
    MatChipsModule,
    MatExpansionModule,
    MatTableModule,
    MatDialogModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    AngularEditorModule
  ],
  exports: [],
  providers: [AuthService, HelpersService],
  bootstrap: [AppComponent]
})
export class AppModule { }
